<template>
  <div>
    <div class="main-wrapper">
      <Header :isLogined="true" />
      <NavBar />

      <router-view></router-view>

      <Footer />
    </div>
  </div>
</template>

<script>
//import AuthService from '../utils/msal';

import Header from '../components/Header/Header';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';

export default {
  name: 'Layout',
  components: { Header, Footer, NavBar },

  data: () => {
    return {};
  },

  beforeMount() {},
};
</script>

<style></style>
